const getSelectEmails = (records: string[] = []) => {
	return records.join(", ");
};

export default getSelectEmails;
